import { getRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function getDeviationTypesRequest() {
	let url = maintenance.getDeviationTypesPath();
	return getRequest(url);
}